import { all, fork } from 'redux-saga/effects';
import { MobileNumberSaga } from './MobileNumberCard';
import { OtpCodeSaga } from './OtpCodeCard';
import { otpTokenSaga } from './OtpTokenCard';
import { passwordSaga } from './PasswordCard';
import { usernameSaga } from './UsernameCard';

export default function* () {
  yield all([
    fork(MobileNumberSaga),
    fork(OtpCodeSaga),
    fork(passwordSaga),
    fork(usernameSaga),
    fork(otpTokenSaga)
  ]);
}
